import GenerateProductTable from './generateProductTable.container';

export default GenerateProductTable